import React from 'react'
import { formatAmountInput, parseAmountInput } from '../../helper/odulOneriImplementation'

/**
 * Parasal alan — yazarken binlik nokta (5.000.000).
 * value/onChange ham rakam string veya number tutar.
 */
const MoneyInput = ({ value, onChange, disabled, readOnly, className, style, id, name, placeholder }) => (
  <input
    id={id}
    name={name}
    type="text"
    inputMode="numeric"
    autoComplete="off"
    className={className}
    style={style}
    disabled={disabled}
    readOnly={readOnly}
    placeholder={placeholder || '0'}
    value={formatAmountInput(value)}
    onChange={(e) => onChange?.(parseAmountInput(e.target.value))}
  />
)

export default MoneyInput
